import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { UserPlus, Share2 } from 'lucide-react';
import SharePlanbloxModal from '../SharePlanbloxModal';

const GrowthFeatureCards = () => {
  const navigate = useNavigate();
  const [shareOpen, setShareOpen] = useState(false);

  return (
    <>
      <SharePlanbloxModal open={shareOpen} onOpenChange={setShareOpen} />

      {/* Share PlanBlox Card */}
      <Card 
        className="hover:shadow-lg transition-all duration-300 border-2 hover:border-primary/30 group bg-[#7FD1C6] dark:bg-[#7FD1C6]/20"
        data-testid="invite-planners-card"
      >
        <CardHeader className="pb-3">
          <div className="flex items-start gap-3">
            <div className="p-2.5 bg-gradient-to-br from-amber-100 to-orange-100 dark:from-amber-900/30 dark:to-orange-900/30 rounded-xl group-hover:scale-110 transition-transform">
              <UserPlus className="h-5 w-5 text-amber-600 dark:text-amber-400" />
            </div>
            <div className="flex-1">
              <CardTitle className="text-lg text-gray-800 dark:text-gray-100">Share PlanBlox</CardTitle>
              <CardDescription className="mt-1 text-gray-600 dark:text-gray-300">
                Earn a credit every time someone joins through your link. Send to entire lists for maximum benefit.
              </CardDescription>
            </div>
          </div>
        </CardHeader>
        <CardContent className="pt-0 space-y-3">
          <Button 
            className="w-full rounded-xl"
            data-testid="share-planblox-btn"
            onClick={() => setShareOpen(true)}
          >
            <Share2 className="h-4 w-4 mr-2" />
            Share PlanBlox
          </Button>
          <p className="text-xs text-center text-gray-600 dark:text-gray-300">
            They get free credits when they join.
          </p>
        </CardContent>
      </Card>
    </>
  );
};

export default GrowthFeatureCards;
